export const translations = {
  gsw: {
    tagline: 'Scheer dir Standort',
    aboutText:
      'Privatsphäri-zerscht temporärs Standort-Teile. Dini Position wird uf dim Grät End-zu-End verschlüsselt — de Server gseht nüt als en verschlüsselte Blob.',
    aboutBadges: 'Zero-Knowledge · E2E-verschlüsselt · Löschd sich automatisch',
    openHeading: 'E teilte Standort öffne',
    modeSimple: 'Eifach',
    modeManual: 'Manuell',
    pasteLabel: 'En wobisch-Link iifüege',
    urlPlaceholder: 'https://wobisch.ch/abc-def-ghi#key=...',
    openButton: 'Öffne',
    slugPlaceholder: 'Slug (z.B. steinmaur-leontica-hermiswil)',
    keyPlaceholder: 'Schlüssel (z.B. qbGpkWavQe5-iPME_NQNXrFEhSrY2GUS...)',
    errorParseUrl: 'De Link hät nöd chönne gläse werde. Stell sicher, dass Slug und Schlüssel drin sind.',
    errorSlugKeyRequired: 'Slug und Schlüssel sind beidi nötig.',
    getApp: 'D App hole',
    directApk: 'Direkter APK-Download',
    openSourceAfterBeta: 'Wird nach de Beta-Phase als Open Source veröffentlicht.',
    faqHeading: 'Wie s funktioniert',
    faqEncryptionQ: 'Wie wird min Standort verschlüsselt?',
    faqEncryptionA:
      'Dis Grät generiert en zuefällige AES-256-Schlüssel und verschlüsselt dini Koordinate lokal, bevor öppis vo dim Handy uusegaht. De verschlüsselt Blob wird zum Server gschickt, und de Schlüssel chunnt id URL-Fragment (de Teil nach em #), wo nie zum Server gschickt wird.',
    faqServerQ: 'Was gseht de Server?',
    faqServerA:
      'Nur en opake, verschlüsselte Blob und en zuefällige Slug. De Server bechunnt nie de Entschlüsseligsschlüssel, also chan er din Standort nöd läse. Er speicheret de Blob temporär und löschd en wenn er ablouft.',
    faqZeroKnowledgeQ: 'Was isch Zero-Knowledge?',
    faqZeroKnowledgeA:
      'Zero-Knowledge bedütet, dass de Server kei Möglichkeit hät, din echte Standort z erfahre. Au wenn d Datebank ghackt würd, fändi en Agriiffer nur verschlüsselti Date, wo ohni de Schlüssel nutzlos sind — und de existiert nur im teilte Link.',
    faqDurationQ: 'Wie lang wird min Standort gspeicheret?',
    faqDurationA:
      'Du wählsch d Duur bim Teile. Wenn de Timer ablouft, löschd de Server d verschlüsslete Date automatisch. Es git kei Möglichkeit, si nachher wiederhärzstelle.',
    faqOpenSourceQ: 'Isch de Quellcode verfüegbar?',
    faqOpenSourceA:
      'Ja. Alli Clients und de Server sind Open Source. Du chasch genau prüefe, weli Date gschickt werded und wie d Verschlüsselig funktioniert.',
    sourceLink: 'Quellcode uf Codeberg',
    footer: 'Privatsphäri-zerscht Standort-Teile',
  },
  de: {
    tagline: 'Teile deinen Standort',
    aboutText:
      'Datenschutzorientiertes temporäres Standort-Teilen. Deine Position wird auf deinem Gerät Ende-zu-Ende verschlüsselt — der Server sieht nur einen verschlüsselten Blob.',
    aboutBadges: 'Zero-Knowledge · E2E-verschlüsselt · Löscht sich automatisch',
    openHeading: 'Einen geteilten Standort öffnen',
    modeSimple: 'Einfach',
    modeManual: 'Manuell',
    pasteLabel: 'Einen wobisch-Link einfügen',
    urlPlaceholder: 'https://wobisch.ch/abc-def-ghi#key=...',
    openButton: 'Öffnen',
    slugPlaceholder: 'Slug (z.B. steinmaur-leontica-hermiswil)',
    keyPlaceholder: 'Schlüssel (z.B. qbGpkWavQe5-iPME_NQNXrFEhSrY2GUS...)',
    errorParseUrl: 'Der Link konnte nicht gelesen werden. Stelle sicher, dass Slug und Schlüssel enthalten sind.',
    errorSlugKeyRequired: 'Slug und Schlüssel sind beide erforderlich.',
    getApp: 'Die App holen',
    directApk: 'Direkter APK-Download',
    openSourceAfterBeta: 'Wird nach der Beta-Phase als Open Source veröffentlicht.',
    faqHeading: 'So funktioniert es',
    faqEncryptionQ: 'Wie wird mein Standort verschlüsselt?',
    faqEncryptionA:
      'Dein Gerät generiert einen zufälligen AES-256-Schlüssel und verschlüsselt deine Koordinaten lokal, bevor etwas dein Handy verlässt. Der verschlüsselte Blob wird zum Server geschickt, und der Schlüssel wird im URL-Fragment (der Teil nach dem #) platziert, das nie zum Server gesendet wird.',
    faqServerQ: 'Was sieht der Server?',
    faqServerA:
      'Nur einen opaken, verschlüsselten Blob und einen zufälligen Slug. Der Server erhält nie den Entschlüsselungsschlüssel und kann daher deinen Standort nicht lesen. Er speichert den Blob temporär und löscht ihn nach Ablauf.',
    faqZeroKnowledgeQ: 'Was ist Zero-Knowledge?',
    faqZeroKnowledgeA:
      'Zero-Knowledge bedeutet, dass der Server keine Möglichkeit hat, deinen tatsächlichen Standort zu erfahren. Selbst bei einem Datenbankeinbruch würde ein Angreifer nur verschlüsselte Daten finden, die ohne den Schlüssel nutzlos sind — und der existiert nur im geteilten Link.',
    faqDurationQ: 'Wie lange wird mein Standort gespeichert?',
    faqDurationA:
      'Du wählst die Dauer beim Teilen. Wenn der Timer abläuft, löscht der Server die verschlüsselten Daten automatisch. Es gibt keine Möglichkeit, sie danach wiederherzustellen.',
    faqOpenSourceQ: 'Ist der Quellcode verfügbar?',
    faqOpenSourceA:
      'Ja. Alle Clients und der Server sind Open Source. Du kannst genau prüfen, welche Daten gesendet werden und wie die Verschlüsselung funktioniert.',
    sourceLink: 'Quellcode auf Codeberg',
    footer: 'Datenschutzorientiertes Standort-Teilen',
  },
  fr: {
    tagline: 'Partagez votre position',
    aboutText:
      'Partage temporaire de position axé sur la vie privée. Votre position est chiffrée de bout en bout sur votre appareil — le serveur ne voit qu\'un blob chiffré.',
    aboutBadges: 'Zero-knowledge · Chiffrement E2E · Expiration automatique',
    openHeading: 'Ouvrir une position partagée',
    modeSimple: 'Simple',
    modeManual: 'Manuel',
    pasteLabel: 'Collez un lien wobisch',
    urlPlaceholder: 'https://wobisch.ch/abc-def-ghi#key=...',
    openButton: 'Ouvrir',
    slugPlaceholder: 'Slug (ex. steinmaur-leontica-hermiswil)',
    keyPlaceholder: 'Clé (ex. qbGpkWavQe5-iPME_NQNXrFEhSrY2GUS...)',
    errorParseUrl: 'Impossible de lire le lien. Assurez-vous qu\'il contient le slug et la clé.',
    errorSlugKeyRequired: 'Le slug et la clé sont tous deux requis.',
    getApp: 'Obtenir l\'application',
    directApk: 'Téléchargement direct de l\'APK',
    openSourceAfterBeta: 'Sera publié en open source après la phase bêta.',
    faqHeading: 'Comment ça marche',
    faqEncryptionQ: 'Comment ma position est-elle chiffrée ?',
    faqEncryptionA:
      'Votre appareil génère une clé AES-256 aléatoire et chiffre vos coordonnées localement avant que quoi que ce soit ne quitte votre téléphone. Le blob chiffré est envoyé au serveur, et la clé est placée dans le fragment d\'URL (la partie après le #) qui n\'est jamais envoyé au serveur.',
    faqServerQ: 'Que voit le serveur ?',
    faqServerA:
      'Seulement un blob opaque et chiffré ainsi qu\'un slug aléatoire. Le serveur ne reçoit jamais la clé de déchiffrement et ne peut donc pas lire votre position. Il stocke le blob temporairement et le supprime à expiration.',
    faqZeroKnowledgeQ: 'Qu\'est-ce que le zero-knowledge ?',
    faqZeroKnowledgeA:
      'Zero-knowledge signifie que le serveur n\'a aucun moyen de connaître votre position réelle. Même en cas de violation de la base de données, un attaquant ne trouverait que des données chiffrées inutiles sans la clé — qui n\'existe que dans le lien partagé.',
    faqDurationQ: 'Combien de temps ma position est-elle conservée ?',
    faqDurationA:
      'Vous choisissez la durée lors du partage. Une fois le délai écoulé, le serveur supprime automatiquement les données chiffrées. Il n\'y a aucun moyen de les récupérer après cela.',
    faqOpenSourceQ: 'Le code source est-il disponible ?',
    faqOpenSourceA:
      'Oui. Tous les clients et le serveur sont open source. Vous pouvez vérifier exactement quelles données sont envoyées et comment le chiffrement fonctionne.',
    sourceLink: 'Code source sur Codeberg',
    footer: 'Partage de position axé sur la vie privée',
  },
  it: {
    tagline: 'Condividi la tua posizione',
    aboutText:
      'Condivisione temporanea della posizione con priorità alla privacy. La tua posizione viene crittografata end-to-end sul tuo dispositivo — il server vede solo un blob crittografato.',
    aboutBadges: 'Zero-knowledge · Crittografia E2E · Scadenza automatica',
    openHeading: 'Apri una posizione condivisa',
    modeSimple: 'Semplice',
    modeManual: 'Manuale',
    pasteLabel: 'Incolla un link wobisch',
    urlPlaceholder: 'https://wobisch.ch/abc-def-ghi#key=...',
    openButton: 'Apri',
    slugPlaceholder: 'Slug (es. steinmaur-leontica-hermiswil)',
    keyPlaceholder: 'Chiave (es. qbGpkWavQe5-iPME_NQNXrFEhSrY2GUS...)',
    errorParseUrl: 'Impossibile leggere il link. Assicurati che contenga slug e chiave.',
    errorSlugKeyRequired: 'Slug e chiave sono entrambi obbligatori.',
    getApp: 'Scarica l\'app',
    directApk: 'Download diretto dell\'APK',
    openSourceAfterBeta: 'Sarà rilasciato come open source dopo la fase beta.',
    faqHeading: 'Come funziona',
    faqEncryptionQ: 'Come viene crittografata la mia posizione?',
    faqEncryptionA:
      'Il tuo dispositivo genera una chiave AES-256 casuale e crittografa le tue coordinate localmente prima che qualsiasi cosa lasci il tuo telefono. Il blob crittografato viene inviato al server, e la chiave viene inserita nel frammento dell\'URL (la parte dopo il #) che non viene mai inviato al server.',
    faqServerQ: 'Cosa vede il server?',
    faqServerA:
      'Solo un blob opaco e crittografato e uno slug casuale. Il server non riceve mai la chiave di decrittazione, quindi non può leggere la tua posizione. Memorizza il blob temporaneamente e lo elimina alla scadenza.',
    faqZeroKnowledgeQ: 'Cos\'è il zero-knowledge?',
    faqZeroKnowledgeA:
      'Zero-knowledge significa che il server non ha modo di conoscere la tua posizione reale. Anche in caso di violazione del database, un aggressore troverebbe solo dati crittografati inutili senza la chiave — che esiste solo nel link condiviso.',
    faqDurationQ: 'Per quanto tempo viene conservata la mia posizione?',
    faqDurationA:
      'Scegli la durata al momento della condivisione. Allo scadere del timer, il server elimina automaticamente i dati crittografati. Non c\'è modo di recuperarli dopo.',
    faqOpenSourceQ: 'Il codice sorgente è disponibile?',
    faqOpenSourceA:
      'Sì. Tutti i client e il server sono open source. Puoi verificare esattamente quali dati vengono inviati e come funziona la crittografia.',
    sourceLink: 'Codice sorgente su Codeberg',
    footer: 'Condivisione della posizione con priorità alla privacy',
  },
  en: {
    tagline: 'Share your location',
    aboutText:
      'Privacy-first temporary location sharing. Your position is end-to-end encrypted on your device — the server only ever sees an opaque blob.',
    aboutBadges: 'Zero-knowledge · E2E encrypted · Auto-expires',
    openHeading: 'Open a shared location',
    modeSimple: 'Simple',
    modeManual: 'Manual',
    pasteLabel: 'Paste a wobisch link',
    urlPlaceholder: 'https://wobisch.ch/abc-def-ghi#key=...',
    openButton: 'Open',
    slugPlaceholder: 'Slug (e.g. steinmaur-leontica-hermiswil)',
    keyPlaceholder: 'Key (e.g. qbGpkWavQe5-iPME_NQNXrFEhSrY2GUS...)',
    errorParseUrl: 'Could not parse URL. Make sure it includes the slug and key.',
    errorSlugKeyRequired: 'Both slug and key are required.',
    getApp: 'Get the app',
    directApk: 'Direct APK download',
    openSourceAfterBeta: 'Will be open-sourced after the beta phase.',
    faqHeading: 'How it works',
    faqEncryptionQ: 'How is my location encrypted?',
    faqEncryptionA:
      'Your device generates a random AES-256 encryption key and encrypts your coordinates locally before anything leaves your phone. The encrypted blob is sent to the server, and the key is placed in the URL fragment (the part after #) which is never sent to the server.',
    faqServerQ: 'What does the server see?',
    faqServerA:
      'Only an opaque, encrypted blob and a random slug. The server never receives the decryption key, so it cannot read your location. It stores the blob temporarily and deletes it when it expires.',
    faqZeroKnowledgeQ: 'What is zero-knowledge?',
    faqZeroKnowledgeA:
      'Zero-knowledge means the server has no way to learn your actual location. Even if the database were breached, an attacker would only find encrypted data that is useless without the key — which only exists in the shared link.',
    faqDurationQ: 'How long is my location stored?',
    faqDurationA:
      'You choose the duration when sharing. Once the timer expires, the server automatically deletes the encrypted data. There is no way to recover it after that.',
    faqOpenSourceQ: 'Is the source code available?',
    faqOpenSourceA:
      'Yes. All clients and the server are open source. You can audit exactly what data is sent and how encryption works.',
    sourceLink: 'Source code on Codeberg',
    footer: 'Privacy-first location sharing',
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof (typeof translations)['en'];
